import BaseService from "@/boot/BaseService";
class PaisService extends BaseService {
    constructor() {
    super(null, "/paises");
  }
  async index() {
    return await this.get("/");
  }

}

export default new PaisService();
